import $ from 'jquery';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';
import {
  toggleEditorHomeMenu,
  calculateFormat,
  calculateFormatDpi,
  resizeDimensions,
  getCanvasBaseZoom,
  composeMetadataCanvasNavText,
} from '~loader/loader-utils';
import { fetchCanvas } from '~src/api';
import { loadEditor } from '~core';
import { onCanvasNotFound } from '~src/errors';

export const openCanvasById = async (canvasId) => {
  window.editorLoader.canvasId = canvasId;

  $('.app-spinner').show();
  $('#sidebar-profile').removeClass('sidebar-profile-open');

  const editorMode = window.urlParams.get('mode') || EDITOR_MODE_DEFAULT;

  toggleEditorHomeMenu();

  try {
    const canvas = await fetchCanvas(canvasId);
    composeMetadataCanvasNavText();
    const { formatWidth, formatHeight } = calculateFormat();
    const dpi = calculateFormatDpi(canvas, window.editorLoader.sourceDPI);

    const { width, height } = resizeDimensions(
      formatWidth,
      formatHeight,
      window.editorLoader.defaultDPI,
      dpi
    );

    const zoomValue = getCanvasBaseZoom(width, height);

    await loadEditor({
      width,
      height,
      zoom: zoomValue,
      editorMode,
    });
  } catch (error) {
    console.error(error);
    $('.app-spinner').hide();
    onCanvasNotFound();
  }
};
